import React, { useState, useEffect, useCallback } from "react";
import "./SideModalOne.css";
import largerlock from "../../images/large-lock.svg";
import { END_URL, IMG_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";

function SideModalOne({
  clssgrop,
  img,
  onLoginChange,
  token,
  detail,
  free_test_sub_modal,
  handleSub,
  buttonlabel
}) {
  const LoginShow = () => {
    onLoginChange(true);
  };

  const LoginShowSub = (subids) => {
    if (subids) {
      try {
        let parsedSubIds;

        if (typeof subids === "string") {
          try {
            parsedSubIds = JSON.parse(subids);
          } catch {
            parsedSubIds = [subids];
          }
        } else if (Array.isArray(subids)) {
          parsedSubIds = subids;
        } else {
          parsedSubIds = [subids];
        }

        localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
      } catch (error) {
        console.error("Failed to save subids to localStorage:", error);
      }
    }
      window.scrollTo({ top: 0, behavior: "smooth" });

      // onLoginChange(true);
  };

  const [ButtonLoad, setButtonLoad] = useState(false);

  const handleNavigete = (link) => {
    if (link) {
      window.location.href = `/${link}`;
    }
  };


  return (
    <div className={`onemodal-cont ${clssgrop}`}>
      <div className="custom-box-wrapper">
  
        <svg className="custom-box-svg" viewBox="-5 0 335 125" preserveAspectRatio="none">
          <polygon
            points="160,0 310,10 310,90 160,100 10,90 10,10"
            fill="#ead7ec"
          />
          <polygon points="310,10 320,20 320,100 310,90" fill="#b190b6" />
          <polygon
            points="0,90 160,100 310,90 320,100 160,110 20,100"
            fill="#a47aa9"
          />
          <polygon
            points="150,0 310,10 310,90 160,100 0,90 0,10"
            fill="#dbc3dc"
            stroke="#7a4fa3"
            strokeWidth="2"
            strokeDasharray="2,2"
            vectorEffect="non-scaling-stroke"
          />
        </svg>

<div className="result-one-mdl">

  
</div>


        <div className="custom-box-content">

          {detail && (

            <div dangerouslySetInnerHTML={{ __html: detail }} />

          )}

          {token ? (
            <button
              // onClick={() => HandlePayment(Hasi)}
              className="handle-sub"
              onClick={() => handleSub(free_test_sub_modal)}
            >
              {buttonlabel ? buttonlabel : 'Get Detailed Report'} {" "}
              <span>
                {" "}
                {!ButtonLoad && (
                  <FontAwesomeIcon className="icc" icon={faArrowRight} />
                )}
              </span>{" "}
              {ButtonLoad && (
                <img
                  src={buttonloader}
                  alt="Loading"
                  style={{ marginLeft: "0px", width: "33px", height: "33px" }}
                />
              )}
            </button>
          ) : (
            <button className="login-btn" onClick={() => LoginShow()}>
              {" "}

              {buttonlabel ? buttonlabel : 'Get Detailed Report'} 
              
              <span>
                {" "}
                <FontAwesomeIcon className="icc" icon={faArrowRight} />
              </span>
            </button>
          )}
        </div>
        
        {img && (

          <img src={`${IMG_URL}/d0/${img}`} alt="Bear illustration" />
          
        )}

        <img src={largerlock} alt="Large lock icon" />
      </div>
    </div>
  );
}

export default SideModalOne;
